import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import Button from 'components/App/Button';
import Loading from 'components/App/Loading';

import {
  LOCATIONS,
  LANDMARK_LIST,
  PLACE_TYPE,
} from 'constants/index';
import { ReactComponent as SortIconSvg } from 'assets/images/location/sort-icon-svg.svg';

import styles from './DataTableFavoritePlace.module.scss';

function SortableHeader({ children, columnSortBy, onSort, style }) {
  return (
    <th className="Table__Header__Row__Content" style={style}>
      <button
        type="button"
        className="SortHeader"
        onClick={() => onSort(columnSortBy)}
      >
        <span>{children}</span>
        <SortIconSvg className="SortHeader__Icon" />
      </button>
    </th>
  );
}

SortableHeader.propTypes = {
  children: PropTypes.node.isRequired,
  columnSortBy: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  style: PropTypes.shape({}),
};

SortableHeader.defaultProps = {
  style: {},
};

function DataTableFavoritePlace(props) {
  const {
    isLoadingLocationList,
    locations,
    onSort,
    startIndex,
    // onDeleteFavorite,
    onShowOnHomepage,
  } = props;

  return (
    <div className={styles.Component}>
      <Loading loading={isLoadingLocationList} loaderOnPage />
      <Table responsive className="Table">
        <thead className="Table__Header">
          <tr className="Table__Header__Row">
            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: '80px' }}
            >
              STT
            </th>

            <SortableHeader
              columnSortBy="placeId"
              onSort={onSort}
              style={{ minWidth: '321px' }}
            >
              Mã chỗ nghỉ | Chỗ nghỉ
            </SortableHeader>

            <SortableHeader
              columnSortBy="market"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Thị trường
            </SortableHeader>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: '160px' }}
            >
              Khu vực
            </th>

            <SortableHeader
              columnSortBy="placeType"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Loại hình
            </SortableHeader>

            <SortableHeader
              columnSortBy="starRating"
              onSort={onSort}
              style={{ minWidth: '160px' }}
            >
              Hạng sao
            </SortableHeader>

            <th
              className="Table__Header__Row__Content text-center"
              style={{ minWidth: '160px' }}
            >
              Đêm phòng
            </th>

            <SortableHeader
              columnSortBy="owner"
              onSort={onSort}
              style={{ minWidth: '180px' }}
            >
              Người phụ trách
            </SortableHeader>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: '160px' }}
            >
              Số điện thoại
            </th>
          </tr>
        </thead>

        <tbody className="Table__Body">
          {locations.map((location, index) => (
            <tr className="Table__Body__Row" key={location._id}>
              <td className="Table__Body__Row__Content text-center">
                {startIndex + index + 1}
              </td>

              <td className="Table__Body__Row__Content">
                <div className="d-flex flex-column">
                  <span className="Content__Id">
                    {location.placeId || location._id}
                  </span>
                  <span className="Content__Name">{location.name}</span>

                  <div className="Action">
                    <Link
                      to={`${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${location._id}`}
                    >
                      <Button
                        outline
                        classes="Action__Button Action__Button__Link"
                      >
                        Xem chi tiết
                      </Button>
                    </Link>
                    <Button
                      outline
                      classes={`Action__Button ${
                        location.isFavorite
                          ? 'Action__Button__Danger'
                          : 'Action__Button__Link'
                      }`}
                      onClick={() =>
                        onShowOnHomepage(location._id, location.isFavorite)
                      }
                    >
                      {location.isFavorite ? 'Ẩn khỏi trang chủ' : 'Thêm vào trang chủ'}
                    </Button>
                  </div>
                </div>
              </td>

              <td className="Table__Body__Row__Content">
                {location.market?.name}
              </td>

              <td className="Table__Body__Row__Content">
                {LANDMARK_LIST.find(
                  (item) => item.value === location.landmarks?.[0],
                )?.label || ''}
              </td>

              <td className="Table__Body__Row__Content">
                {PLACE_TYPE[location.placeType]?.label}
              </td>

              <td className="Table__Body__Row__Content">
                {`${location.starRating} sao`}
              </td>

              <td className="Table__Body__Row__Content text-center">
                {location.totalNights || 0}
              </td>

              <td className="Table__Body__Row__Content">
                {location.market?.partnerServiceManager?.fullName}
              </td>

              <td className="Table__Body__Row__Content">
                {
                  location.placeContacts?.find((item) => item.group === 'MAIN')
                    ?.children?.[0]?.phoneNumbers?.[0]
                }
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

DataTableFavoritePlace.propTypes = {
  isLoadingLocationList: PropTypes.bool.isRequired,
  locations: PropTypes.instanceOf(Array),
  onSort: PropTypes.func,
  startIndex: PropTypes.number.isRequired,
  // onDeleteFavorite: PropTypes.func.isRequired,
  onShowOnHomepage: PropTypes.func.isRequired,
};

DataTableFavoritePlace.defaultProps = {
  locations: [],
  onSort: () => {},
};

export default memo(DataTableFavoritePlace);
